import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImgLoaderDirective } from './img-loader.directive';

@NgModule({
  declarations: [ImgLoaderDirective],
  imports: [CommonModule],
  exports: [ImgLoaderDirective]
})
export class CsImgLoaderModule {}
